// src/utils/request.js
import axios from 'axios'
import { Message, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth' // 引入token工具类
import router from '@/router' // 新增：导入路由实例
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 从环境变量获取基础URL
  timeout: 10000, // 请求超时时间

  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 加载动画实例
let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 显示加载动画
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.1)'
    })
    // 添加token
    if (store.getters.token) {
      config.headers['sessionKey'] = '9YWBZSLDLKOVLJYAEB2FTJK2VHHBMY'
      config.headers['token'] = `${store.getters.token || ''}`

    }

    // GET请求参数处理
    if (config.method === 'get' && config.params) {
      // 处理空字符串参数
      Object.keys(config.params).forEach(key => {
        if (config.params[key] === '') {
          delete config.params[key]
        }
      })
    }

    return config
  },
  error => {
    // 关闭加载动画
    if (loadingInstance) loadingInstance.close()
    console.error('请求拦截错误:', error)
    Message.error('请求配置错误，请稍后重试')
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  async (response) => {
    // 关闭加载动画
    if (loadingInstance) loadingInstance.close()
    const res = response.data
console.log(' response.data', response.data)
    if (res instanceof Blob) {
      return response
    }
    console.log('响应数据:', res)
    // 根据后端约定的状态码处理
    if (res.code) {
      // 错误提示
      // Message.error(res.msg || '操作失败，请稍后重试')

      // 特殊状态码处理
      switch (res.code) {
        case 200: // 成功
          return res
        case 401: // 未授权
          router.push('/login')
          break
        case 404: // 资源不存在
          router.push('NotFound')
          break
        default:
          break
      }
      Message.error(res.msg || '接口异常')

    } else {
      // 成功返回数据
      Message.error(res.msg || '操作失败，请稍后重试')
    }
  },
  error => {
    // 关闭加载动画
    if (loadingInstance) loadingInstance.close()

    console.error('响应错误:', error)

    // 网络错误处理
    let errorMsg = '网络异常，请检查网络连接'
    if (error.code) {
      switch (error.response.code) {
        case 9:
          errorMsg = '登录已过期，请重新登录'
          store.dispatch('user/logout')
          this.$router.push('login');
          break
        default:
          errorMsg = `请求错误 (${error.response.code})`
      }
    } else if (error.message.includes('timeout')) {
      errorMsg = '请求超时，请稍后重试'
    }

    Message.error(errorMsg)
    return Promise.reject(error)
  }
)

// 封装常用请求方法
const request = {
  /**
   * GET请求
   * @param {string} url 请求地址
   * @param {object} params 请求参数
   * @param {object} config 额外配置
   * @returns {Promise}
   */
  get(url, params = {}, config = {}) {
    return service({
      url,
      method: 'get',
      params,
      ...config
    })
  },
  /**
   * POST请求
   * @param {string} url 请求地址
   * @param {object} data 请求数据
   * @param {object} config 额外配置
   * @returns {Promise}
   */
  post(url, data = {}, config = {}) {
    return service({
      url,
      method: 'post',
      data,
      ...config
    })
  },
  exportFile(url, params = {}, config = {}) {
    return service({
      url,
      responseType: 'blob', // 关键：指定响应为Blob类型
      method: 'get',
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      params,
      ...config
    })
  },

  /**
   * PUT请求
   * @param {string} url 请求地址
   * @param {object} data 请求数据
   * @param {object} config 额外配置
   * @returns {Promise}
   */
  put(url, data = {}, config = {}) {
    return service({
      url,
      method: 'put',
      data,
      ...config
    })
  },

  /**
   * DELETE请求
   * @param {string} url 请求地址
   * @param {object} params 请求参数
   * @param {object} config 额外配置
   * @returns {Promise}
   */
  delete(url, params = {}, config = {}) {
    return service({
      url,
      method: 'delete',
      params,
      ...config
    })
  },

  /**
   * 上传文件
   * @param {string} url 请求地址
   * @param {FormData} formData 表单数据
   * @param {function} onProgress 进度回调
   * @returns {Promise}
   */
  upload(url, formData, onProgress) {
    return service({
      url,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        if (onProgress) {
          const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100)
          onProgress(percent)
        }
      }
    })
  }
}

export default request